// app.routes.ts
import { Route } from '@angular/router';
import { NotFoundComponent } from '@awo-care/shared-ui';
import { CostUnitHandlerComponent } from './core/components/cost-unit-handler.component';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('./home/home.routes').then((mod) => mod.HOME_ROUTES),
  },
  {
    path: '',
    loadChildren: () =>
      import('./legal/legal.routes').then((mod) => mod.LEGAL_ROUTES),
  },
  {
    // Entry point for cost-unit links from print material — no search value.
    path: 'kostenstelle',
    component: CostUnitHandlerComponent,
    data: {
      title: $localize`:@@seo.costUnit.title:Kostenstelle`,
      noindex: true,
    },
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
    data: {
      title: $localize`:@@seo.notFound.title:Seite nicht gefunden`,
      noindex: true,
    },
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: {
      title: $localize`:@@seo.notFound.title:Seite nicht gefunden`,
      noindex: true,
    },
  },
];
